module.exports = __webpack_public_path__ + "static/media/ghost.0c046ed5.png";